import { Info } from 'lucide-react'
import type { Message } from '@/types/conversations'

interface TimeoutErrorMessageProps {
  message: Message
}

export function TimeoutErrorMessage({ message }: TimeoutErrorMessageProps) {
  const isShort = (message.content?.length || 0) < 80

  return (
    <div className="mb-4 mt-4 min-w-0">
      <div className={`flex gap-2 px-4 py-2 bg-amber-50 dark:bg-amber-950/30 border border-amber-200 dark:border-amber-800 rounded-lg ${isShort ? 'items-center justify-center' : 'items-start'}`}>
        <Info className={`h-4 w-4 text-amber-600 dark:text-amber-400 shrink-0 ${isShort ? '' : 'mt-0.5'}`} />
        <span className="text-sm text-amber-800 dark:text-amber-200 [overflow-wrap:anywhere] whitespace-pre-wrap">
          {message.content}
        </span>
      </div>
    </div>
  )
}
